import { enrichMeterLabel, revealLimitLabel } from 'features/customers/constants/apiMeters'
import { FEATURES, type FeatureKind } from 'features/customers/constants/features'
import sortBy from 'lodash/sortBy'
import union from 'lodash/union'

import { type EFeatureNames, PER_TIER_KEYS, planFeaturesForTier } from '@albacross/types'

export const CONTACT_PROVIDER_LABELS = {
  cognism: 'Cognism',
  cognism_free: 'Cognism Free',
  hunter: 'Hunter',
  waterfall: 'Waterfall.io',
}
export const REVEAL_API_LIMIT_LABELS = {
  revealApiRequestsLimit: revealLimitLabel('requests'),
  revealApiIdentifiedLimit: revealLimitLabel('identified'),
  revealApiUniqueIdentifiedIpsLimit: revealLimitLabel('uniqueIdentifiedIps'),
}

export const ENRICH_API_LIMIT_LABELS = {
  enrichApiRequestsLimit: `${enrichMeterLabel('requests')} limit`,
}

export const getFeatureLabel = (name: string) => FEATURES[name]?.label

export const getFeatureDescription = (name: string) => FEATURES[name]?.description

// An undeclared key is read-only, so its kind only decides how the value is printed.
export const featureKind = (name: string, value: unknown, planValue: unknown): FeatureKind => {
  const declared = FEATURES[name]?.kind

  if (declared) return declared

  const known = value ?? planValue

  if (typeof known === 'boolean') return 'flag'
  if (typeof known === 'string') return 'text'

  return 'limit'
}

export const getCustomerFeaturesData = (planFeatures: any = {}, features: any = {}, tier: any) => {
  const planValues: any = planFeaturesForTier(planFeatures, tier)

  // Every declared key gets a row, read-only ones included: the panel holding them starts shut, so
  // listing them costs nothing and a key that is missing on one customer and present on the next
  // reads as a bug rather than as "nobody stored it".
  const rows = union(Object.keys(FEATURES), Object.keys(features))
    .filter(name => !PER_TIER_KEYS.includes(name as EFeatureNames))
    .map(key => ({ name: key, feature: features[key], planFeature: planValues[key] }))

  const declaredOrder = Object.keys(FEATURES)

  return sortBy(rows, ({ name }) => {
    const at = declaredOrder.indexOf(name)

    return at === -1 ? declaredOrder.length : at
  })
}

export const isFeatureManaged = (name: string) => !!FEATURES[name]?.editable

export const featureGroupOf = (name: string) => FEATURES[name]?.group ?? 'other'
